const DOCUMENT = 'ORG_CANCELLATION_POLICY_';

const actions = {
  CREATE_INITIAL_FORM: DOCUMENT + 'CREATE_INITIAL_FORM',
  CREATE_EDIT_FORM: DOCUMENT + 'CREATE_EDIT_FORM',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_ERROR: DOCUMENT + 'LOAD_ERROR',
  CREATE_REQUEST: DOCUMENT + 'CREATE_REQUEST',
  CREATE_SUCCESS: DOCUMENT + 'CREATE_SUCCESS',
  CREATE_ERROR: DOCUMENT + 'CREATE_ERROR',
  EDIT_REQUEST: DOCUMENT + 'EDIT_REQUEST',
  EDIT_SUCCESS: DOCUMENT + 'EDIT_SUCCESS',
  EDIT_ERROR: DOCUMENT + 'EDIT_ERROR',
  DELETE_REQUEST: DOCUMENT + 'DELETE_REQUEST',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  DELETE_ERROR: DOCUMENT + 'DELETE_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  createInitialForm: () => ({ type: actions.CREATE_INITIAL_FORM }),
  createEditForm: () => ({ type: actions.CREATE_EDIT_FORM }),
  changeNestedProperty: data => ({ type: actions.CHANGE_NESTED_PROPERTY, payload: data }),
  loadDataRequest: () => ({ type: actions.LOAD_REQUEST }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadDataError: () => ({ type: actions.LOAD_ERROR }),
  createRequest: data => ({ type: actions.CREATE_REQUEST, payload: data }),
  createSuccess: data => ({ type: actions.CREATE_SUCCESS, payload: data }),
  createError: data => ({ type: actions.CREATE_ERROR, payload: data }),
  editRequest: data => ({ type: actions.EDIT_REQUEST, payload: data }),
  editSuccess: data => ({ type: actions.EDIT_SUCCESS, payload: data }),
  editError: data => ({ type: actions.EDIT_ERROR, payload: data }),
  deleteRequest: () => ({ type: actions.DELETE_REQUEST }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  deleteError: () => ({ type: actions.DELETE_ERROR }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
